import React from "react";
import {
  Box,
  Button,
  Grid2,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { InvoiceItem } from "@rentablo/api/apiv1";
import TaxIcon from "@icons/myicons/help-wheel.svg?react";
import { toCurrency } from "@helpers";
import { GainLossTypography } from "@rentablo/components";

const Controls = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  display: flex;
  margin-left: ${({ theme }) => theme.spacing(2)};
`;

const Row = styled.div``;

export interface CashbackSummaryRowMobileProps {
  invoiceItem: InvoiceItem;
  billingCycleId?: number;
  showInvoice: (ids: number[]) => void;
  onTaxHelperOpen: (accountHolderId: number) => void;
}

export const CashbackSummaryRowMobile = (
  props: CashbackSummaryRowMobileProps
) => {
  const { invoiceItem, showInvoice, billingCycleId, onTaxHelperOpen } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Row>
      <Grid2 container spacing={2}>
        <Grid2 size={7}>
          <div>
            <Typography variant="body3">
              {`${invoiceItem.accountHolderReference!.firstName} ${
                invoiceItem.accountHolderReference!.lastName
              }`}
            </Typography>
            <Typography variant="body3">{`${toCurrency(
              invoiceItem.totalPortfolioCommission
            )}
                      / ${toCurrency(invoiceItem.totalAgio)}`}</Typography>
            <Typography
              variant="caption"
              color="textSecondary"
              fontWeight="600"
              component="p"
            >
              {t("domains.cashback.dashboard.summary.trailerCommission")}
            </Typography>
          </div>
        </Grid2>
        <Grid2 size={5}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Box
              sx={{
                width: "150px",
                [theme.breakpoints.down("sm")]: {
                  width: "auto",
                  textAlign: "right",
                  paddingRight: theme.spacing(4),
                },
              }}
            >
              {!billingCycleId && (
                <Typography variant="body3" color="textSecondary">
                  {t("domains.cashback.dashboard.summary.afterBilling")}
                </Typography>
              )}
              {billingCycleId && (
                <GainLossTypography
                  value={invoiceItem.internalTransaction?.amount || 0}
                >
                  {toCurrency(invoiceItem.internalTransaction?.amount || 0)}
                </GainLossTypography>
              )}
              <Typography
                variant="caption"
                color="textSecondary"
                fontWeight="600"
                component="p"
              >
                {t("domains.cashback.dashboard.summary.yourCashback")}
              </Typography>
            </Box>
            <Controls>
              <IconButton
                size="small"
                disabled={!billingCycleId}
                onClick={() =>
                  showInvoice(invoiceItem.securityCommissionIds || [])
                }
                sx={{
                  boxShadow: theme.shadows[1],
                  border: `1px solid ${theme.palette.border.secondary}`,
                }}
              >
                <VisibilityIcon fontSize="small" />
              </IconButton>
            </Controls>
          </Box>
        </Grid2>
      </Grid2>
      {billingCycleId && (
        <Box mt={2}>
          <Button
            color="primary"
            variant="text"
            size="small"
            startIcon={<TaxIcon width="16px" />}
            onClick={() => {
              if (!invoiceItem?.accountHolderReference?.id) return;
              onTaxHelperOpen(invoiceItem?.accountHolderReference?.id);
            }}
          >
            {t("domains.cashback.dashboard.summary.taxHelper")}
          </Button>
        </Box>
      )}
    </Row>
  );
};
